import { AfterViewInit, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css'],
    standalone: false
})
export class ConfirmComponent implements AfterViewInit {

  @Input() titolo:string;
  @Input() messaggio:string;
  @Input() tipo:string;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal) {
  }

  @HostListener('document:keydown.enter', ['$event'])
  onEnterPress(event: KeyboardEvent) {
    this.confirm();
  }

  ngAfterViewInit(): void {
    // Modifica la larghezza del modale dopo che la vista è stata inizializzata
    const modalDialog: any = document.querySelector('.modal-dialog');
    if (modalDialog) {
      modalDialog.style.maxWidth = '600px';  // Imposta la larghezza
      modalDialog.style.margin = '10rem auto';     // Centra il modale
    }
  }

  passBack(ref:any) {
    this.passEntry.emit(ref);
  }

  openModal(titolo: string, messaggio: string, tipo: string) {
    console.log('openModal()');
    this.titolo = titolo;
    this.messaggio = messaggio;
  }

  successDialogClose() {
    console.log('successDialogClose()');
  }

  confirm() {
    this.passBack('confirm');
    this.modalService.dismissAll();
  }

  chiudi() {
    this.modalService.dismissAll();
  }

}
